module.exports = __webpack_public_path__ + "img/icon_marketing_off.df84830c.svg";